<template>
  <b-dropdown right variant="custom-primary">
    <template v-slot:button-content>
      <i class="fas fa-plus mr-2"></i> Nouvelle question
    </template>
    <b-dropdown-item
      :to="{
        name: baseUrl + '-create',
        params: { id: currentChecklist.id, type: 'qcm' },
      }"
      exact
      ><i class="fas fa-plus align-middle mr-1"></i> Question a chox multiples
      (QCM)</b-dropdown-item
    >
    <b-dropdown-item
      :to="{
        name: baseUrl + '-create',
        params: { id: currentChecklist.id, type: 'qrm' },
      }"
      exact
      ><i class="fas fa-plus align-middle mr-1"></i>Question a réponse multiples
      (QRM)</b-dropdown-item
    >
    <b-dropdown-item
      :to="{
        name: baseUrl + '-create',
        params: { id: currentChecklist.id, type: 'qvf' },
      }"
      exact
      ><i class="fas fa-plus align-middle mr-1"></i>Question Vrai/Faux
      (QVF)</b-dropdown-item
    >
    <b-dropdown-item
      :to="{
        name: baseUrl + '-create',
        params: { id: currentChecklist.id, type: 'qrn' },
      }"
      exact
      ><i class="fas fa-plus align-middle mr-1"></i>Question a réponse numérque
      (QRN)</b-dropdown-item
    >
    <b-dropdown-item
      :to="{
        name: baseUrl + '-create',
        params: { id: currentChecklist.id, type: 'qrc' },
      }"
      exact
      ><i class="fas fa-plus align-middle mr-1"></i>Question a réponse courte
      (QRC)</b-dropdown-item
    >
    <b-dropdown-item
      :to="{
        name: baseUrl + '-create',
        params: { id: currentChecklist.id, type: 'qrl' },
      }"
      exact
      ><i class="fas fa-plus align-middle mr-1"></i>Question a réponse longue
      (QRL)</b-dropdown-item
    >
  </b-dropdown>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    baseUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  props: ['currentChecklist'],
};
</script>

<style scoped></style>
